import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import formatCurrency from '@afosto/utils/formatCurrency';

const ServiceCostRow = ({ serviceCost, currency }) => (
  <TableRow>
    <TableCell>
      {serviceCost.is_percentage
        ? `${serviceCost.description} (${serviceCost.amount}%)`
        : serviceCost.description}
    </TableCell>
    <TableCell>{formatCurrency(serviceCost?.total / 100, currency)}</TableCell>
  </TableRow>
);

ServiceCostRow.propTypes = {
  serviceCost: PropTypes.object.isRequired,
  currency: PropTypes.string,
};

ServiceCostRow.defaultProps = {
  currency: 'EUR',
};

export default ServiceCostRow;
